module.exports = __webpack_public_path__ + "static/media/payment.3c7165e8.svg";